import { useSelector } from "react-redux";
import Sockets from "../../utils/sockets";
import Papa from "papaparse";

export const useReportDataLoader = () => {
  const socketapiData = useSelector((state) => state?.users?.apiInfo);
  const user = useSelector((state) => state?.users?.user);
  const { readData } = Sockets(socketapiData, user);

  const loadReportData = async (recordForEdit, setData, setTextContent, setShowLoader, setError, reportType) => {
    try {
      setShowLoader(true);
      setError("");
      
      const file = recordForEdit?.file;
      if (!file) {
        setError("No file available");
        setShowLoader(false);
        return;
      }

      const result = await readData(file, "eod");
      
      if (reportType?.toLowerCase() === "goldman") {
        // For Goldman reports, just set the text content
        setTextContent(result);
        setData([]);
      } else {
        // For other reports, parse as CSV
        const csvString = await Papa.parse(result);
        setData(csvString?.data || []);
        setTextContent(result);
      }
    } catch (error) {
      console.error("Error loading report data:", error);
      setError("Failed to load report data");
      setTextContent("");
      setData([]);
    } finally {
      setShowLoader(false);
    }
  };

  const handleDataEdit = (params, rows, setRows) => {
    const updatedRows = rows.map((row) =>
      row.id === params.id ? { ...row, [params.field]: params.value } : row
    );
    setRows(updatedRows);
  };

  return { loadReportData, handleDataEdit };
};
